import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { searchMyPaymentRequests } from '@src/api'
import { DefaultApiSearchMyPaymentRequestsRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchSearchMyPaymentRequests = (
  params: DefaultApiSearchMyPaymentRequestsRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => searchMyPaymentRequests(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.SEARCH_MY_PAYMENT_REQUESTS, params],
    placeholderData: keepPreviousData,
  })
}
